var head = document.getElementsByTagName('head')[0];

var isTest = window && !!window["jasmine"];

/** Version Info as Define in index.html */
export const AppInfo = {
    Version: (head && head.getAttribute("data-infoma-appversion")) || '<unbekannt>',
    PatchLevel: (head && head.getAttribute("data-infoma-patchlevel")) || '<unbekannt>',
    IsTest : isTest
};
